import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowLeft, ArrowRight, Quote } from "lucide-react";

const QUOTES = [
  {
    text: "LW&Co completely transformed our bathroom and the result is stunning. The workmanship was first class and Luke's team were tidy, respectful and finished on time. Highly recommend!",
    name: "Mel", project: "Bathroom Renovation",
  },
  {
    text: "Building a 320m² home is no small feat but LW&Co made it look easy. From foundations to final fit-out the quality is exceptional and we couldn't be happier with our new home.",
    name: "Andy & Nat", project: "320m² New Build",
  },
  {
    text: "Our 140m² kitchen renovation was handled brilliantly by LW&Co. The design, the finish, the communication — all outstanding. Our kitchen is now the heart of our home.",
    name: "Miles & Maree", project: "140m² Kitchen Renovation",
  },
  {
    text: "LW&Co tackled our kitchen, bathrooms, lift shaft and extension all at once and never missed a beat. Complex job, flawless result. Luke and the team delivered exactly what they promised.",
    name: "Joe & Pam", project: "Kitchen, Bathrooms, Lift Shaft & Extension",
  },
];

export default function Testimonials() {
  const [index, setIndex] = useState(0);
  const q = QUOTES[index];

  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-24 sm:py-32 bg-white border-t border-black/10">
      <div className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
        <motion.div initial={{ opacity: 0, y: 32 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}>
          <p className="text-[11px] font-bold uppercase tracking-[0.3em] text-gold mb-8">Client word</p>
          <Quote size={30} className="text-gold mx-auto mb-8" strokeWidth={1.25} />
          <div className="min-h-[240px] sm:min-h-[200px] flex items-center justify-center">
            <AnimatePresence mode="wait">
              <motion.figure key={index} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }} transition={{ duration: 0.5 }} data-testid="testimonial-quote">
                <blockquote className="font-display font-medium text-2xl sm:text-3xl lg:text-4xl text-black leading-snug tracking-tight">
                  “{q.text}”
                </blockquote>
                <figcaption className="mt-8">
                  <div className="text-sm font-bold uppercase tracking-[0.15em] text-black">{q.name}</div>
                  <div className="text-[11px] font-bold uppercase tracking-[0.25em] text-gold mt-1.5">{q.project}</div>
                </figcaption>
              </motion.figure>
            </AnimatePresence>
          </div>
          <div className="mt-10 flex items-center justify-center gap-4">
            <button data-testid="testimonial-prev" aria-label="Previous testimonial"
              onClick={() => setIndex((index - 1 + QUOTES.length) % QUOTES.length)}
              className="p-3 border border-black/15 text-black/50 hover:border-gold hover:text-gold transition-colors">
              <ArrowLeft size={16} />
            </button>
            <span className="text-xs font-bold tracking-[0.25em] text-black/40" data-testid="testimonial-counter">
              {String(index + 1).padStart(2, "0")} / {String(QUOTES.length).padStart(2, "0")}
            </span>
            <button data-testid="testimonial-next" aria-label="Next testimonial"
              onClick={() => setIndex((index + 1) % QUOTES.length)}
              className="p-3 border border-black/15 text-black/50 hover:border-gold hover:text-gold transition-colors">
              <ArrowRight size={16} />
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
